import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TeamEngageDashboardComponent } from './team-engage-dashboard.component';

export const teamEngageDashboardRoutes: Routes = [
  {
    path: '',
    component: TeamEngageDashboardComponent,
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(teamEngageDashboardRoutes)],
  exports: [RouterModule],
})
export class TeamEngageDashboardRoutingModule {}
